import { FormControl, FormGroup } from "@angular/forms";

export const updateFormControlIfDifferent = (formGroup: FormGroup) => {
  const lastSavedValues = new Map<string, any>();

  return (newConfig: { [key: string]: any }) => {
    Object.keys(newConfig).forEach(key => {
      const control = formGroup.controls[key] as FormControl;
      const newValue = newConfig[key];
      const lastSavedValue = lastSavedValues.get(key);

      if (control && lastSavedValue !== newValue) {
        control.setValue(newValue);
        lastSavedValues.set(key, newValue);
      }
    });
  };
}
